import html2canvas from "html2canvas";

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const waitForRender = async (preDelay = 200, postDelay = 1800) => {
  try {
    await delay(preDelay);
    await new Promise((resolve, reject) => {
      try {
        window.requestAnimationFrame(resolve);
      } catch (err) {
        reject(err);
      }
    });
    await delay(postDelay);
  } catch (error) {
    console.error("Error interno en waitForRender:", error);
    throw error;
  }
};

export const captureElementAsImage = async (ref, maxWidth, maxHeight) => {
  const canvas = await html2canvas(ref.current, {
    scale: 2,
    backgroundColor: "#ffffff",
  });

  const imgData = canvas.toDataURL("image/jpeg", 1.0);
  let imgWidth = maxWidth;
  let imgHeight = (canvas.height * imgWidth) / canvas.width;

  if (imgHeight > maxHeight) {
    imgHeight = maxHeight;
    imgWidth = (canvas.width * imgHeight) / canvas.height;
  }

  return { imgData, imgWidth, imgHeight };
};

export const loadImageAsBase64 = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export const getShipmentSections = async (reportData) => {
  return [
    {
      title: "Datos del envío",
      lines: [
        `Código de bulto: ${reportData.shipmentData.shipmentCode}`,
        `Código de IMEI: ${reportData.shipmentData.imei}`,
        `Referencia interna: ${reportData.shipmentData.numRefClient}`,
        `Remitente: ${reportData.shipmentData.senderName}`,
        `Destinatario: ${reportData.shipmentData.destinationName}`,
      ],
    },
    {
      title: "Trazabilidad logística",
      lines: [
        `Fecha y hora de envío (admisión): ${reportData.admissionTraceability.admissionEventDate}`,
        `Último evento: ${reportData.admissionTraceability.lastEventName}`,
        `Ubicación del último evento: ${reportData.admissionTraceability.lastEventLocation}`,
        `Fecha y hora del último evento: ${reportData.admissionTraceability.lastEventDate}`,
      ],
    },
    {
      title: "Información del dispositivo",
      lines: [
        `Modelo de dispositivo: ${reportData.deviceInfo.deviceModel}`,
        `Número de serie: ${reportData.deviceInfo.deviceSerialNumber}`,
        `Tipo de trazabilidad: ${reportData.deviceInfo.traceabilityType}`,
        `Retraso en el inicio: ${reportData.deviceInfo.periodMinuteGuard}`,
        `Intervalo de registro: ${reportData.deviceInfo.periodMinuteMeasure}`,
      ],
    },
    {
      title: "Datos registrados",
      lines: [
        `Primer punto: ${reportData.registeredData.startDate}`,
        `Hora de stop: ${reportData.registeredData.stopDate}`,
        `Número de registros: ${reportData.registeredData.recordCount}`,
        `Tiempo de grabación: ${reportData.registeredData.recordingTime}`,
      ],
    },
    {
      title: "Resumen de datos",
      lines: [
        `Temperatura mínima: ${reportData.summaryData.tempMin}`,
        `Temperatura máxima: ${reportData.summaryData.tempMax}`,
        `Promedio: ${reportData.summaryData.average}`,
        `MKT: ${reportData.summaryData.mkt}`,
      ],
    },
  ];
};

export const getShipmentAlarmSections = async (reportData) => {
  return [
    {
      title: "Configuración de alarmas",
      lines: [
        `Configuración alarma activa: ${reportData.alarmConfiguration.activeAlarmConfig}`,
        `Límite mínimo de temperatura: ${reportData.alarmConfiguration.minTemperatureLimit}`,
        `Límite máximo de temperatura: ${reportData.alarmConfiguration.maxTemperatureLimit}`,
        `Nivel de sensibilidad de impacto: ${reportData.alarmConfiguration.impactSensitivityLevel}`,
        `Tiempo de temperatura fuera de rango: ${reportData.alarmConfiguration.temperatureOutOfRangeTime}`,
        `Límite mínimo de humedad: ${reportData.alarmConfiguration.minHumidityLimit}`,
        `Límite máximo de humedad: ${reportData.alarmConfiguration.maxHumidityLimit}`,
        `Tiempo de humedad fuera de rango: ${reportData.alarmConfiguration.humidityOutOfRangeTime}`,
        `Tiempo de caja abierta fuera de rango: ${reportData.alarmConfiguration.openBoxOutOfRangeTime}`,
      ],
    },
  ];
};
